module.exports = __webpack_public_path__ + "img/promptpay.3487c776.png";